import { Children, cloneElement, isValidElement, memo } from 'react';

import Menu, { MenuProps } from '@material-ui/core/Menu';
import { MenuItemProps } from '@material-ui/core/MenuItem';
import clsx from 'clsx';

import { useStyles } from './DropdownMenu.styles';

export const DropdownMenu = memo(
  ({
    className,
    open,
    children,
    ...props
  }: MenuProps & {
    className?: string;
  }) => {
    const classes = useStyles();

    return (
      <Menu
        className={clsx([className])}
        open={open}
        classes={{ paper: classes.menuWrapper, list: classes.list }}
        {...props}
      >
        {Children.map(children, child => {
          if (!isValidElement<MenuItemProps>(child)) {
            return child;
          }

          return cloneElement(child, { className: classes.menuItem });
        })}
      </Menu>
    );
  },
);
